<template>
	<div class="white-box">
		<h3 class="box-title">CLIENTES NUEVOS {{ month }}</h3>
		<line-chart :options="options" :chart-data="datacollection"></line-chart>
	</div>
</template>
<script>
	import LineChart from '@/components/charts/basics/ChartLine.vue';
	export default {
		props: ['user', 'isAuth'],
		components: {
			LineChart,
		},
		data () {
			return {
				data: null,
				labels: [],
				series: [],
				month: moment().format('MMMM'),

				datacollection: null,

				chart: null,

				options: {
					responsive: true,
					legend: {
						display: false,
					},
					scales: {
						yAxes: [{
							ticks: {
								beginAtZero: true,
								callback: function (value) { if (Number.isInteger(value)) { return value; } },
								stepSize: 10
							}
						}]
					},
				},
			}
		},
		created() {
			this.init()
		},
		methods: {
			init() {
				this.getData()
			},
			getData() {
				this.$http.get('admin/charts/new/customers/per/day')
				.then(response => {
					this.data = response.body
					this.loadData()
				})
			},
			loadData() {
				var that = this
				var labels = []
				var series = []
				
				$.each(this.data, function(index, value) {
					var date = moment(index).format('D')
					var month = that.$options.filters.ucfirst(date)
					labels.push(month)
					series.push(value)
				})

				this.labels = labels

				var data = {
					label: 'Clientes',
					data: series
				}

				this.series = [data]

				this.datacollection = {
					labels: this.labels,
					datasets: this.series,
				}
			},
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/management/dashboard/views/charts/newCustomersPerDay.vue